module.exports = __webpack_public_path__ + "img/pubag-back.5fba7a46.png";